const API_URL = process.env.REACT_APP_API_URL || 'https://skolify-backend.onrender.com';

export default API_URL;